const initPropertyGallery = () => {
  const wrappers = document.querySelectorAll('[data-property-gallery-wrapper]');

  if (!wrappers.length) {
    return;
  }

  const body = document.body;

  wrappers.forEach((wrapper) => {
    const strip = wrapper.querySelector('[data-property-gallery]');
    const modal = wrapper.querySelector('[data-property-gallery-modal]');

    if (!strip || !modal) {
      return;
    }

    const thumbs = Array.from(strip.querySelectorAll('[data-gallery-index]'));
    if (!thumbs.length) {
      return;
    }

    const images = thumbs.map((thumb) => {
      const img = thumb.querySelector('img');
      const explicitSrc = thumb.dataset.gallerySrc || thumb.getAttribute('href') || '';
      return {
        src: explicitSrc,
        caption: thumb.getAttribute('data-caption') ?? '',
        alt: img?.getAttribute('alt') ?? '',
      };
    });

    const modalImage = modal.querySelector('[data-gallery-modal-image]');
    const modalCaption = modal.querySelector('[data-gallery-modal-caption]');
    const modalCaptionText = modal.querySelector('[data-gallery-modal-caption-text]');
    const closeButtons = modal.querySelectorAll('[data-gallery-close]');
    const prevButton = modal.querySelector('[data-gallery-prev]');
    const nextButton = modal.querySelector('[data-gallery-next]');

    if (!modalImage || !modalCaption || !prevButton || !nextButton) {
      return;
    }

    let currentIndex = 0;
    let keyListener;

    const setActiveThumb = (index) => {
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
    };

    const updateModalContent = () => {
      const item = images[currentIndex];
      if (!item) {
        return;
      }
      modalImage.src = item.src;
      modalImage.alt = item.alt || modalImage.alt;
      modalCaption.textContent = item.caption;
      if (modalCaptionText) {
        modalCaptionText.textContent = item.caption || '';
      }
      setActiveThumb(currentIndex);
    };

    const openModal = (index) => {
      currentIndex = index;
      updateModalContent();
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      body.classList.add('has-modal');

      keyListener = (event) => {
        if (event.key === 'Escape') {
          closeModal();
        } else if (event.key === 'ArrowRight') {
          showNext();
        } else if (event.key === 'ArrowLeft') {
          showPrev();
        }
      };
      document.addEventListener('keydown', keyListener);
      nextButton.focus();
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      body.classList.remove('has-modal');
      if (keyListener) {
        document.removeEventListener('keydown', keyListener);
        keyListener = undefined;
      }
    };

    const showPrev = () => {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      updateModalContent();
    };

    const showNext = () => {
      currentIndex = (currentIndex + 1) % images.length;
      updateModalContent();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        openModal(index);
      });

      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal(index);
        }
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    prevButton.addEventListener('click', showPrev);
    nextButton.addEventListener('click', showNext);

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal();
      }
    });
  });
};

export default initPropertyGallery;
